import { render } from "./NegocioPeriodoActivoMultiselect.vue?vue&type=template&id=bebd28e8"
import script from "./NegocioPeriodoActivoMultiselect.vue?vue&type=script&lang=js"
export * from "./NegocioPeriodoActivoMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__